"use client"

import { Dialog, DialogContent } from "@/components/ui/dialog"
import { SubscriptionPlansMain } from "@/app/(app)/plans/page"

export default function PlansDialog({
  isPlansDialogOpen,
  setIsPlansDialogOpen,
}: {
  isPlansDialogOpen: boolean
  setIsPlansDialogOpen: React.Dispatch<React.SetStateAction<boolean>>
}) {
  return (
    <Dialog open={isPlansDialogOpen} onOpenChange={setIsPlansDialogOpen}>
      <DialogContent
        className={
          "max-w-screen lg:max-w-[900px]-lg max-h-[900px] px-0 lg:max-w-screen-lg"
        }
      >
        <SubscriptionPlansMain
          isOpen={isPlansDialogOpen}
          onOpenChange={setIsPlansDialogOpen}
        />
      </DialogContent>
    </Dialog>
  )
}
